import { Injectable } from "@angular/core";
import { ApiService } from "../../core/services/api.service";
import {
  MacroGroupsDTO,
  MacroGroupTemplateDTO,
  MacrosArea,
} from "../../shared/DTO/MacroGroupsDTO";
import { Alert, AlertInstance } from "./alerts.model";
import { Observable } from "rxjs/Observable";
import { AlertType, ClientTariff, AlertsMap } from "../../shared/constants";
import { SessionStateService } from "../../core/services/session-state.service";
import { HouseAlert } from "./alerts.model_new";

@Injectable()
export class AlertsService {
  alertsLoading: boolean[];

  constructor(
    private apiService: ApiService,
    private sessionStateService: SessionStateService
  ) {
    this.alertsLoading = [];
  }

  /** NEW API */
  getHouseAlerts(): Observable<any> {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.apiService
      .get(`/alerts/house/${houseId}/alert`)
      .map((alerts) => {
        return alerts;
      });
  }

  updateBudgetControl(state: boolean, value: number) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        conditions: {
          monthlyConsumptionPrediction: value,
        },
        isEnabled: state,
      },
    };
    return this.apiService.put(
      `/alerts/house/${houseId}/alert/budgetControl`,
      body
    );
  }

  addNoConsumptionByFridge(moduleId: string, analysisPeriod: number) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        moduleId: moduleId,
        conditions: {
          analysisPeriod: analysisPeriod,
        },
      },
    };
    return this.apiService.post(
      `/alerts/house/${houseId}/alert/noConsumptionByFridge `,
      body
    );
  }

  updateNoConsumptionByFridge(
    alertId: string,
    moduleId: string,
    analysisPeriod: number
  ) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        moduleId: moduleId,
        conditions: {
          analysisPeriod: analysisPeriod,
        },
      },
    };
    return this.apiService.patch(
      `/alerts/house/${houseId}/alert/noConsumptionByFridge?alertId=` + alertId,
      body
    );
  }

  deleteNoConsumptionByFridge(alertId: string) {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.apiService.delete(
      `/alerts/house/${houseId}/alert/noConsumptionByFridge?alertId=` + alertId
    );
  }

  addSignificantConsumptionIncrease(moduleId: string, consumptionIncrease) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        moduleId: moduleId,
        conditions: {
          consumptionIncrease: consumptionIncrease,
        },
      },
    };
    return this.apiService.post(
      `/alerts/house/${houseId}/alert/significantConsumptionIncrease `,
      body
    );
  }

  updateSignificantConsumptionIncrease(
    alertId: string,
    moduleId: string,
    consumptionIncrease
  ) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        moduleId: moduleId,
        conditions: {
          consumptionIncrease: consumptionIncrease,
        },
      },
    };
    return this.apiService.patch(
      `/alerts/house/${houseId}/alert/significantConsumptionIncrease?alertId=` +
        alertId,
      body
    );
  }

  deleteSignificantConsumptionIncrease(alertId: string) {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.apiService.delete(
      `/alerts/house/${houseId}/alert/significantConsumptionIncrease?alertId=` +
        alertId
    );
  }

  changeNoProduction(previousState) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        enabled: !previousState,
      },
    };
    return this.apiService.post(
      `/alerts/house/${houseId}/alert/noProduction `,
      body
    );
  }

  deleteNoProduction(alterId: string) {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.apiService.delete(
      `/alerts/house/${houseId}/alert/noProduction?alertId=` + alterId
    );
  }

  changeEquipmentLeftOnTooLong(previousState) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        enabled: !previousState,
      },
    };
    return this.apiService.post(
      `/alerts/house/${houseId}/alert/equipmentLeftOnTooLong `,
      body
    );
  }

  deleteEquipmentLeftOnTooLong(alterId: string) {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.apiService.delete(
      `/alerts/house/${houseId}/alert/equipmentLeftOnTooLong?alertId=` + alterId
    );
  }

  changeUnusualWeekHourConsumption(previousState) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        enabled: !previousState,
      },
    };
    return this.apiService.post(
      `/alerts/house/${houseId}/alert/unusualWeekHourConsumption `,
      body
    );
  }

  deleteUnusualWeekHourConsumption(alterId: string) {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.apiService.delete(
      `/alerts/house/${houseId}/alert/unusualWeekHourConsumption?alertId=` +
        alterId
    );
  }

  changeDeviceDisconnection(previousState) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        enabled: !previousState,
      },
    };
    return this.apiService.post(
      `/alerts/house/${houseId}/alert/deviceDisconnection `,
      body
    );
  }

  deleteDeviceDisconnection(alertId: string) {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.apiService.delete(
      `/alerts/house/${houseId}/alert/deviceDisconnection?alertId=` + alertId
    );
  }

  addConsumptionOutsideEconomicPeriod(moduleId: string) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        moduleId: moduleId,
      },
    };
    return this.apiService.post(
      `/alerts/house/${houseId}/alert/consumptionOutsideEconomicPeriod`,
      body
    );
  }

  updateConsumptionOutsideEconomicPeriod(
    isEnabled: boolean,
    moduleId: string,
    email: boolean,
    pushNotification: boolean
  ) {
    const houseId = this.sessionStateService.getHouse().houseId;
    const body = {
      alertParameters: {
        moduleId: moduleId,
        isEnabled: isEnabled,
        deliveryChannel: {
          email: email,
          pushNotification: pushNotification,
        },
      },
    };
    return this.apiService.patch(
      `/alerts/house/${houseId}/alert/consumptionOutsideEconomicPeriod`,
      body
    );
  }

  deleteConsumptionOutsideEconomicPeriod(alertId: string) {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.apiService.delete(
      `/alerts/house/${houseId}/alert/consumptionOutsideEconomicPeriod?alertId=` +
        alertId
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/alerts/alerts.service.ts